import { useEffect } from "react"

export const useEntityApi = ({
  name,
  urlName,
  key,
  requestApiEntity,
  hold,
  refresh,
}) => {
  useEffect(() => {
    if (!hold) {
      requestApiEntity({ name, urlName, uuid: key })
    }
  }, [refresh, key])
}

export const useEntityApiList = ({
  name,
  urlName,
  key,
  requestApiEntityList,
  hold,
  refresh,
}) => {
  useEffect(() => {
    if (!hold) {
      requestApiEntityList({ name, urlName })
    }
  }, [refresh, key])
}
